import {
  dateToLongFormatWithZone,
  formatConversationTime,
  dateToDayMonthFormatWithZone,
} from './format-time-utils';
/**
 * Returns 2023-03-22 at 6:50 pm UTC
 */

export function dateDisplay(date: Date, timezone: string): string {
  const formattedDate = dateToLongFormatWithZone(date, timezone);
  const formattedTime = formatConversationTime(date, timezone);
  return `${formattedDate} at ${formattedTime}`;
}

/**
 * Returns October 23, 2023
 */
export function dateDisplayWithoutTime(date: Date, timezone: string): string {
  const formattedDate = dateToLongFormatWithZone(date, timezone);
  return `${formattedDate}`;
}

/**
 * Returns 27 Oct
 */
export function dateDisplayDateMonth(date: Date, timezone: string): string {
  const formattedDate = dateToDayMonthFormatWithZone(date, timezone);
  return `${formattedDate}`;
}
